import { render } from "./MicrosoftIcon.vue?vue&type=template&id=1bba1bc8"
import script from "./MicrosoftIcon.vue?vue&type=script&lang=js"
export * from "./MicrosoftIcon.vue?vue&type=script&lang=js"
script.render = render

export default script